const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Autoplaying video without controls needs a way to stop it (WCAG 2.2.2).
function addPlayToggle(video, toggleClass) {
	const button = document.createElement('button');
	button.type = 'button';
	button.className = toggleClass;

	const sync = () => {
		const playing = !video.paused;
		button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
		button.dataset.state = playing ? 'playing' : 'paused';
	};

	button.addEventListener('click', () => (video.paused ? video.play() : video.pause()));
	video.addEventListener('play', sync);
	video.addEventListener('pause', sync);
	video.after(button);
	sync();
}

export function initAutoplayVideo(video, toggleClass) {
	if (reducedMotion()) {
		video.removeAttribute('autoplay');
		video.pause();
	}

	if (toggleClass && !video.controls) addPlayToggle(video, toggleClass);
}
